import "./styles/Footer.css";
import { FaInstagram, FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function Footer() {
  const horarios = [
    { dia: "Segunda-feira a Sexta-Feira", horas: "07:00 - 22:00" },
    { dia: "Sábado", horas: "07:00 - 20:00" },
    { dia: "Domingo", horas: "08:00 - 20:00" },
  ];

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* ---------------- LOGO + SOCIAL ---------------- */}
        <div className="footer-social-block">
          <h3 className="footer-title">Arena Central</h3>

          <div className="footer-social">
            <a
              href="https://instagram.com/arenacentralsj"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram className="footer-icon" />
            </a>

            <a
              href="https://wa.me/5532999649956"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp className="footer-icon" />
            </a>
          </div>
        </div>

        {/* ---------------- HORÁRIOS ---------------- */}
        <div className="footer-horarios">
          <h4>Horário de funcionamento</h4>

          <ul>
            {horarios.map((item, index) => (
              <li key={index}>
                <span>{item.dia}</span>
                <span>{item.horas}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* ---------------- LINKS ---------------- */}
        <div className="footer-links">
          <Link to="/politica-cancelamento">Política de cancelamento</Link>

          <p>
            Desenvolvido por{" "}
            <a href="https://instagram.com/e.cipriani" target="_blank">
              Enzo Cipriani
            </a>
          </p>
        </div>
      </div>

      {/* ---------------- COPYRIGHT ---------------- */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} Arena Central — Todos os direitos reservados.
      </div>
    </footer>
  );
}
